<div class="absolute invisible h-0 inset-x-0 bottom-0 -mx-[2px]" #providerRef></div>

<input
  readonly
  [value]="selected?.value"
  [class.text-slate-400]="selected?.key === ''"
  class="em-select-searchable__value !outline-0 block w-full pr-8 pointer-events-none select-none"
  />

@if (canClear) {
  <button
    type="button"
    class="absolute right-7 top-1/2 z-10 -translate-y-1/2 p-1 text-slate-400 hover:text-slate-600"
    aria-label="Clear selection"
    (click)="onClear($event)"
    >
    <svg class="w-4 h-4">
      <use xlink:href="assets/icons/symbols.svg#close"></use>
    </svg>
  </button>
}

@if (showOptionList) {
  <ng-template teleport="dropdown">
    <dropdown-list
      [provider]="provider"
      (closed)="showOptionList = false"
      >
      <div class="px-2.5 pt-0.5 mb-1.5">
        <input
          [(ngModel)]="search"
          (focusin)="searchFocus.emit(true)"
          (focusout)="searchFocus.emit(false)"
          class="em-select-searchable__search px-1.5 py-0.5 block w-full rounded"
          />
      </div>
      @for (option of options$|async; track option.key) {
        <button
          type="button"
          class="text-left inline-flex items-center px-2.5 py-0.5"
          [value]="option.key"
          (click)="onValueChange(option)"
          >
          <span [class.text-slate-400]="option.key === ''">{{option.value}}</span>
          @if (option.key === this.value && option.key !== '') {
            <span class="pl-2 5 ml-auto">
              <svg class="text-sky-500 w-4 h-4">
                <use xlink:href="assets/icons/symbols.svg#check"></use>
              </svg>
            </span>
          }
        </button>
      }
    </dropdown-list>
  </ng-template>
}
